module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/797da41ea8725ca406d63babf790766e.png";